const getEnvConfig = () => {
  const env = process.env.REACT_APP_ENV || "demo";
  const getEnvUrls = () => {
    switch (env) {
      case "dev":
        return {
          apiBaseUrl: process.env.REACT_APP_DEV_API_BASE_URL,
          userDashboardUrl: process.env.REACT_APP_DEV_USER_DASHBOARD_URL,
          websocketUrl: process.env.REACT_APP_DEV_WEBSOCKET_URL,
          diceSearchBaseURL: process.env.REACT_APP_DEV_DICE_SEARCH_BASE_URL,
          monsterSearchBaseURL:
            process.env.REACT_APP_DEV_MONSTER_SEARCH_BASE_URL,
          vendorId: process.env.REACT_APP_DEV_DICE_VENDOR_ID,
          monsterVendorID: process.env.REACT_APP_DEV_MONSTER_VENDOR_ID,
          monsterUsaVendorID: process.env.REACT_APP_DEV_MONSTER_USA_VENDOR_ID,
          irmtCandidateVendorId: process.env.REACT_APP_DEV_IRMT_VENDOR_ID,
          irmtCandidateSearchUrl:
            process.env.REACT_APP_DEV_IRMT_CANDIDATE_SEARCH_BASE_URL,
          irmtCandidateTokenId:
            process.env.REACT_APP_DEV_IRMT_CANDIDATE_TOKEN_ID,
        };
      case "local":
        return {
          apiBaseUrl: process.env.REACT_APP_LOCAL_API_BASE_URL,
          userDashboardUrl: process.env.REACT_APP_DEV_USER_DASHBOARD_URL,
          websocketUrl: process.env.REACT_APP_LOCAL_WEBSOCKET_URL,
          diceSearchBaseURL: process.env.REACT_APP_LOCAL_DICE_SEARCH_BASE_URL,
          monsterSearchBaseURL:
            process.env.REACT_APP_LOCAL_MONSTER_SEARCH_BASE_URL,
          vendorId: process.env.REACT_APP_LOCAL_DICE_VENDOR_ID,
          monsterVendorID: process.env.REACT_APP_LOCAL_MONSTER_VENDOR_ID,
          monsterUsaVendorID: process.env.REACT_APP_LOCAL_MONSTER_USA_VENDOR_ID,
          irmtCandidateVendorId: process.env.REACT_APP_LOCAL_IRMT_VENDOR_ID,
          irmtCandidateSearchUrl:
            process.env.REACT_APP_LOCAL_IRMT_CANDIDATE_SEARCH_BASE_URL,
          irmtCandidateTokenId:
            process.env.REACT_APP_LOCAL_IRMT_CANDIDATE_TOKEN_ID,
        };
      case "demo":
        return {
          apiBaseUrl: process.env.REACT_APP_DEMO_API_BASE_URL,
          userDashboardUrl: process.env.REACT_APP_DEMO_USER_DASHBOARD_URL,
          websocketUrl: process.env.REACT_APP_DEMO_WEBSOCKET_URL,
          diceSearchBaseURL: process.env.REACT_APP_DEMO_DICE_SEARCH_BASE_URL,
          monsterSearchBaseURL:
            process.env.REACT_APP_DEMO_MONSTER_SEARCH_BASE_URL,
          vendorId: process.env.REACT_APP_DEMO_DICE_VENDOR_ID,
          monsterVendorID: process.env.REACT_APP_DEMO_MONSTER_VENDOR_ID,
          monsterUsaVendorID: process.env.REACT_APP_DEMO_MONSTER_USA_VENDOR_ID,
          irmtCandidateVendorId: process.env.REACT_APP_DEMO_IRMT_VENDOR_ID,
          irmtCandidateSearchUrl:
            process.env.REACT_APP_DEMO_IRMT_CANDIDATE_SEARCH_BASE_URL,
          irmtCandidateTokenId:
            process.env.REACT_APP_DEMO_IRMT_CANDIDATE_TOKEN_ID,
        };
      case "production":
        return {
          apiBaseUrl: process.env.REACT_APP_PROD_API_BASE_URL,
          userDashboardUrl: process.env.REACT_APP_PROD_USER_DASHBOARD_URL,
          websocketUrl: process.env.REACT_APP_PROD_WEBSOCKET_URL,
          diceSearchBaseURL: process.env.REACT_APP_PROD_DICE_SEARCH_BASE_URL,
          monsterSearchBaseURL:
            process.env.REACT_APP_PROD_MONSTER_SEARCH_BASE_URL,
          vendorId: process.env.REACT_APP_PROD_VENDOR_ID,
          monsterVendorID: process.env.REACT_APP_PROD_MONSTER_VENDOR_ID,
          monsterUsaVendorID: process.env.REACT_APP_PROD_MONSTER_USA_VENDOR_ID,
          irmtCandidateVendorId: process.env.REACT_APP_PROD_IRMT_VENDOR_ID,
          irmtCandidateSearchUrl:
            process.env.REACT_APP_PROD_IRMT_CANDIDATE_SEARCH_BASE_URL,
          irmtCandidateTokenId:
            process.env.REACT_APP_PROD_IRMT_CANDIDATE_TOKEN_ID,
        };
      default:
        return {
          apiBaseUrl: process.env.REACT_APP_DEFAULT_API_BASE_URL,
          userDashboardUrl: process.env.REACT_APP_DEFAULT_USER_DASHBOARD_URL,
          websocketUrl: process.env.REACT_APP_DEFAULT_WEBSOCKET_URL,
          diceSearchBaseURL: process.env.REACT_APP_DEFAULT_DICE_SEARCH_BASE_URL,
          monsterSearchBaseURL:
            process.env.REACT_APP_DEFAULT_MONSTER_SEARCH_BASE_URL,
          vendorId: process.env.REACT_APP_DEFAULT_DICE_VENDOR_ID,
          monsterVendorID: process.env.REACT_APP_DEFAULT_MONSTER_VENDOR_ID,
          monsterUsaVendorID:
            process.env.REACT_APP_DEFAULT_MONSTER_USA_VENDOR_ID,
          irmtCandidateVendorId: process.env.REACT_APP_DEFAULT_IRMT_VENDOR_ID,
          irmtCandidateSearchUrl:
            process.env.REACT_APP_DEFAULT_IRMT_CANDIDATE_SEARCH_BASE_URL,
          irmtCandidateTokenId:
            process.env.REACT_APP_DEFAULT_IRMT_CANDIDATE_TOKEN_ID,
        };
    }
  };

  const envUrls = getEnvUrls();

  return {
    isLocal: env === "local",
    baseURLs: {
      resumeParserBaseURL: envUrls.apiBaseUrl,
      vyLabsBaseURL: envUrls.apiBaseUrl,
      userDashboardURL: envUrls.userDashboardUrl,
      diceSearchBaseURL: envUrls.diceSearchBaseURL,
      monsterSearchBaseURL: envUrls.monsterSearchBaseURL,
      irmtCandidateSearchBaseURL: envUrls.irmtCandidateSearchUrl,
    },
    WebSocketUrl: envUrls.websocketUrl,
    vendorId: envUrls.vendorId,
    monsterVendorID: envUrls.monsterVendorID,
    monsterUsaVendorID: envUrls.monsterUsaVendorID,
    irmtCandidateVendorId: envUrls.irmtCandidateVendorId,
    job_public_url: process.env.REACT_APP_JOB_PUBLIC_URL,
    irmt_candidate_token_id: envUrls.irmtCandidateTokenId,

    signUpUrl: "/users/signup/",
    loginUrl: "/users/signin/",
    sendOtp: "/users/send-otp",
    verifyOtp: "/users/verify-otp",
    // Resume Parser Api's : -
    parseResumeUrl: "/files/get-upload-urls/",
    processUploadedFile: "/resumes/process-uploaded-file/",
    get_unparsed_resumes_count: "/resumes/process-status",
    find_similar_resumes: "/resumes/find-similar",
    parse_url_resume: "/resumes/process-shared-file",
    update_resume_by_candidateid: "/resumes/update",
    search_resumes: "/resumes/search",
    get_resume_by_id: "/resumes/get",
    delete_candidate_resume_by_fileid: "/resumes/delete-files",
    get_resume_presigned_url: "/resumes/get-presigned-url",
    process_excel_url: "/resumes/process-excel",
    link_candidate_resume: "/resumes/link-candidate-file",
    download_resume: "/resumes/get-download-url",

    // Chat Channel Api's : -
    create_Chat_Channel_Url: "/chatbot/create_chat_channel",
    get_Chat_Channels_Url: "/chatbot/get_chat_channels",
    get_Chat_Messages_Url: "/chatbot/get_chat_messages",
    send_Chat_Message_Url: "/chatbot/send_chat_message",
    process_Message_Url: "/chatbot/process-message",
    delete_Chat_Channel_Url: "/chatbot/delete_chat_channel",
    generate_Job_Description: "/openai/generate-job-description/",
    renewAccessToken: "/users/renew-access-token/",

    //Candidate Related API's
    candidate_list: "/candidates/search",
    create_candidate: "/candidates/create/",
    get_candidate_by_id: "/candidates",
    simple_search_candidates: "/candidates/search",
    simple_search_candidates_excel_export: "/candidates/search/export",
    candidate_export_fields:"/candidates/export/fields",
    candidate_documents_create: "/candidates/documents/create",
    candidate_documents_geturl: "/candidates/documents/get-upload-url",
    candidate_documents_list: "/candidates/documents/list",
    delete_candidate_documents: "/candidates/documents/delete",
    candidate_filter_export: "/candidates/search/export",
    email_history_candidate: "/contact/email-history/candidate",
    candidate_remarks_track_list:"/tracking/candidate",
    candidate_remarks_track_update:"/candidates/tracks/update",
    candidate_remarks_track_delete:"/candidates/tracks/delete",

    //Jobs Related API's
    jobs_list: "/jobs/search",
    get_job_details_by_id: "/jobs",
    update_jobs_status: "/jobs/update-status",
    create_job: "/jobs/create/",
    update_job: "/jobs/update/",
    get_jobs_status: "/jobs/by-status",
    search_jobs: "/jobs/search",
    job_simple_search: "/jobs/search",
    jobs_by_candidate: "/jobs/by-candidate",
    jobs_document_get_upload_url: "/jobs/documents/get-upload-url",
    jobs_document_create: "/jobs/documents/create",
    jobs_document_delete: "/jobs/documents/delete",
    jobs_document_list: "/jobs/documents/list",
    jobs_process_jd: "/jobs/process-jd",
    jobs_process_excel: "/jobs/process-excel",

    //Client Related API's
    create_Client: "/clients/create/",
    update_client: "/clients/update/",
    create_client_contact: "/clients/contacts/create",
    update_client_contact: "/clients/contacts/update",
    delete_client_contact: "/clients/contacts",
    search_client_contacts: "/clients/contacts/search",
    get_Clients_List: "/clients/list/",
    get_Client_Details: "/clients",
    search_clients: "/clients/search",
    clients_documents_create: "/clients/documents/create",
    clients_documents_geturl: "/clients/documents/get-upload-url",
    clients_documents_list: "/clients/documents/list",
    delete_clients_documents: "/clients/documents/delete",
    create_client_tracking: "/clients/update-track-fields",
    create_Candidate_Tracking_History: "/applications/create",
    get_Tracking_History_By_Candidate: "/applications-by-candidate",
    get_Job_List_By_Client: "/jobs/by-client",
    get_Applicationsy_By_Job: "/applications-by-job",
    search_job_desc: "resumes/search-job-desc",
    scheduling_interview: "/interviews/create",
    interview_display: "/interviews/list",
    delete_interview: "/interviews/delete",
    update_interview: "/interviews/update",
    interview_by_id: "/interviews",
    interview_by_application_id: "/interviews/by-application",
    interview_email_preview: "/interviews/email-preview",
    interview_by_candidate: "/interviews/by-candidate",
    interview_panel_set:"/interviews/panel/set",
    interview_panel_feedback:"/interviews/panel/feedback",
    get_interview_panel_details:"/interviews/panel",
    apllications_list: "/applications",
    get_recuirter_by_id: "/users",
    get_interview_by_time_range: "/interviews/by-time-range",
    update_client_info: "/clients/update-info-fields",
    update_application: "/applications/update",
    applications_tracks_update: "/applications/tracks/update",
    applications_tracks_delete: "/applications/tracks/delete",
    tracking_application: "/tracking/application",
    candidate_conversation: "/chatbot/process-candidate-message",
    job_conversation: "/chatbot/process-job-message",
    get_current_conversation_title: "/chatbot/create_channel_title",
    delete_job_details: "/jobs/delete",
    delete_client_details: "/clients/delete",
    delete_candidate_details: "/candidates/delete",
    change_password: "/users/change-password",
    client_tracking: "/tracking/client",
    get_candidate_track_by_id: "/candidates/by-user",
    create_job_url: "/jobs/share",
    show_url_job_details: "/jobs/shared",
    upload_candidate_image: "/candidates/upload-image",
    upload_user_image: "/users/upload-image",
    users_remove_image: "/users/remove-image",
    candidates_remove_image: "/candidates/remove-image",
    candidate_tracked_by_me: "/applications-by-user",
    recommend_jobs: "/jobs/recommend",
    update_candidate_details: "/candidates/update",
    create_run_set_id: "/files/create-run-set",
    get_vendor_details_by_id: "/vendors",
    get_Vendors_List: "/vendors/list/",
    create_vendors: "/vendors/create/",
    update_vendors_info_fields: "/vendors/update-info-fields",
    update_vendors_track_fields: "/vendors/update-track-fields",
    vendors_tracking_list: "/vendors/tracking-list",
    vendors_search: "/vendors/search",
    candidates_by_vendor: "/candidates/by-vendor",
    create_vendor_contacts: "/vendors/contacts/create",
    edit_vendor_contact: "/vendors/contacts/update",
    delete_vendor_contact: "/vendors/contacts",
    email_history_client: "/contact/email-history/client",
    process_client_excel_url: "/clients/process-excel",

    add_user_to_tenant: "/tenants/add-user",
    list_members_of_tenant: "/tenants/list-users",
    create_tenant_url: "/tenants/create",
    update_member_role: "/tenants/update-user-role",
    remove_member: "/tenants/remove-user",
    create_invite_link: "/tenants/share-invite",
    join_from_invite_link: "/tenants/join-from-share",
    get_tenant_details: "/tenants/get",
    get_vendor_file_upload_url: "/vendors/get-upload-url",
    view_vendor_file_url: "/vendors/get-view-url",

    // Portals Api's :-
    diceSearchLoginURL: "/portals/dice/login",
    dice_candidate_profile_view: "/portals/dice/profile/",
    dice_basic_search_url: "/portals/dice/search",

    monster_token_url: "/portals/foundit/login",
    monster_view: "/portals/foundit/profile",
    monster_search: "/portals/foundit/search",

    irmt_candidate_call_stage: "/portals/irmt/call-stages",
    irmt_candidate_view: "/portals/irmt/candidate/profile",
    irmt_candidate_search_country: "/portals/irmt/countries",
    irmt_candidate_recruiters: "/portals/irmt/recruiters",
    irmt_candidate_search: "/portals/irmt/search",

    monster_view_usa: "/portals/monsterus/candidate/profile",
    monster_token_usa_url: "/portals/monsterus/login",
    monster_search_usa: "/portals/monsterus/search",

    // Admin Metrics Api's :-

    overall_Candidates_Count: "/metrics/candidates/count",
    overall_Clients_Count: "/metrics/clients/count",
    overall_Active_Jobs_Count: "/metrics/jobs/active",
    admin_Candidates_Created_Today: "admin/metrics/candidates/count-today",
    get_Admin_Clients_Count: "admin/metrics/clients/count",
    admin_recent_track_history: "admin/metrics/recent-track-history",
    admin_recruitment_overview: "admin/metrics/recruitment-overview",
    admin_job_pipeline: "admin/metrics/job-pipeline",
    admin_recruitment_performance: "admin/metrics/recruiters-performance",
    admin_team_workload: "admin/metrics/team-workload",
    admin_recruitment_funnel: "admin/metrics/recruitment-funnel",
    admin_metrics_job_applications: "/admin/metrics/job-applications",
    admin_metrics_recruiter_applications:
      "/admin/metrics/recruiter-applications",

    // Member Metrics Api's :-

    get_candidates_stagecount_byuser: "metrics/candidates-stagecount-byuser",
    fetch_Total_Candidate_Count: "metrics/candidates/count",
    get_Job_CountBy_Month: "metrics/job-created-onmonth",
    fetch_Active_Jobs: "metrics/jobs/active",
    fetch_by_call_stage: "metrics/portals/candidates/stages",
    get_candidate_by_stage: "metrics/user/candidatebystage",
    fetch_Total_Candidate_Count_By_User: "metrics/user/candidates/count",
    recent_tracks: "metrics/user/recenttracks",
    get_today_tracks_by_user: "metrics/user/todaytracks",

    // Others Api's :-

    chatbot_execute_schedule_interview: "/chatbot/execute_decorator",
    get_candidates_by_notes: "/candidates/by-notes",
    get_subscription_details: "/billing/subscription",
    dashboard_metrics_login: "api/auth/login",
    users_update: "/users/update",
    select_free_trial_plan: "/billing/checkout-session",
    update_subscription_plan: "/billing/portal-session",

    // User Forgot Password API:-
    user_forgot_password: "/users/forgot-password",
    user_reset_password: "/users/reset-password",

    // Super Admin Related API:-
    get_one_tenant_resumes_statistics: "/resumes/statistics",
    get_all_tenant_resumes_statistics: "/superadmin/resume-statistics",

    //Email Related API :-
    reach_out_candidate_email: "/contact/email-candidate",
    job_blast_for_candidates: "/contact/jobs-blast",
    email_client: "/contact/email-client",
    email_vendor: "/contact/email-vendor",
    email_history_vendor: "/contact/email-history/vendor",

    //Employee Related API :-
    employee_create: "/employees/create",
    employee_update: "/employees/update",
    employee_delete: "/employees/delete",
    get_employee_detail: "/employees",

    create_employee_bank_details: "/employees/bank-details/create",
    update_employee_bank_details: "/employees/bank-details/update",
    delete_employee_bank_details: "/employees/bank-details/delete",
    get_employee_bank_details_list: "/employees/bank-details/list",
    get_employee_bank_detail: "/employees/bank-details",

    create_employee_contact_details: "/employees/employee-contacts/create",
    update_employee_contact_details: "/employees/employee-contacts/update",
    delete_employee_contact_details: "/employees/employee-contacts/delete",
    get_employee_contact_details_list: "/employees/employee-contacts/list",
    get_employee_contact_detail: "/employees/employee-contacts",

    create_employee_bgv_records_details: "/employees/bgv-records/create",
    update_employee_bgv_records_details: "/employees/bgv-records/update",
    delete_employee_bgv_records_details: "/employees/bgv-records/delete",
    get_employee_bgv_records_details_list: "/employees/bgv-records/list",
    get_employee_bgv_records_detail: "/employees/bgv-records",

    // Preview Related API :-
    reach_out_candidate_email_preview: "/contact/email-candidate/preview",
    job_blast_for_candidates_preview: "/contact/jobs-blast/preview",
    email_client_preview: "/contact/email-client/preview",
    email_vendor_preview: "/contact/email-vendor/preview",

    //Get Plan Details API : -
    get_all_plan_details: "/billing/plans",

    // Feedback Related API:-
    send_feedback: "/feedback",
    list_feedback: "/feedback/list",

    //  Tenant Logo Related API :-
    upload_tenant_logo: "/tenants/upload-logo",
    remove_tenant_logo: "/tenants/remove-logo",

    // Notification Related APIs :-
    notifications: "/notifications",
    notifications_read_all: "/notifications/read-all",
    notifications_read_by_id: "/notifications/read",

    // online/offline tracking Related APIs :-
    send_user_active_track: "/users/heartbeat",
    get_all_online_users_from_tenant: "/tenants/online-users",

    // Tenants field-definitions APIs :-
    tenant_field_definitions_list: "/tenants/field-definitions/list",
    tenant_field_definitions_create: "/tenants/field-definitions/create",
    tenant_field_definitions_update: "/tenants/field-definitions/update",
    tenant_field_definitions_delete: "/tenants/field-definitions/delete",
    tenants_field_definitions_reorder: "/tenants/field-definitions/reorder",

    // Callback Reminders APIs :-
    callback_reminders: "/callback-reminders",
    callback_reminders_create: "/callback-reminders/create",
    callback_reminders_delete: "/callback-reminders/delete",
    callback_reminders_update: "/callback-reminders/update",

    // Custom Portals Credentials APIs :-
    create_custom_portal_credentials: "/portals/credentials/create",
    update_custom_portal_credentials: "/portals/credentials/update",
    delete_custom_portal_credentials: "/portals/credentials/delete",
    get_custom_portal_credentials: "/portals/credentials",

    // Member Dashboard APIs :-
    metrics_recruiter_dashboard_summary: "metrics/recruiter-dashboard-summary",
    metrics_recent_activity: "metrics/recent-activity",
    metrics_candidate_workspace: "metrics/candidate-workspace",
    metrics_recruiter_dashboard_followups:
      "metrics/recruiter-dashboard-followups",
    metrics_job_workspace: "/metrics/job-workspace",

    //Daily-Reports API's : -
    get_all_reports: "/report/list",
    submit_daily_report: "/report/create",
    update_report: "/report/update",
    delete_report: "/report/delete",
    get_report_details: "/report/get",

    //Invoices-Page API's :-
    get_invoice_candidates: "/invoice/candidates",
    invoice_create: "/invoice/create",
    invoice_preview: "/invoice/preview",
    invoice_calculate_billing: "/invoice/calculate/billing",
    invoice_calculate_margin: "/invoice/calculate/margin",
    invoice_download: "/invoice/pdf",
    invoice_update: "/invoice/update",
    invoice_get: "/invoice/get",
    change_invoice_status: "/invoice/status",

    //Super Admin Dashboard APIs :-
    superadmin_metrics_activity_by_tenant:
      "/superadmin/metrics/activity/by-tenant",
    export_superadmin_metrics_activity_by_tenant:
      "/superadmin/metrics/activity/by-tenant/export",
    superadmin_metrics_activity_by_user: "/superadmin/metrics/activity/by-user",
    export_superadmin_metrics_activity_by_user:
      "/superadmin/metrics/activity/by-user/export",
    superadmin_tenant_subscription: "/superadmin/tenants/subscription",

    //Invoice-Configuration Page API's :-
    submit_financial_profile: "/tenants/financial-profiles/create",
    update_financial_profile: "/tenants/financial-profiles/update",
    get_financial_profile_list: "/tenants/financial-profiles/list",
    delete_financial_profile: "/tenants/financial-profiles/delete",

    get_config_list: "/tax-config/list",
    submit_tax_create: "/tax-config/create",
    update_tax_config: "/tax-config/update",
    delete_tax_config: "/tax-config/delete",

    // call stages and custom fields APIs :-
    tenants_application_stages_list: "/tenants/application-stages/list",
    tenants_create_application_stage: "/tenants/application-stages/create",
    tenants_update_application_stage: "/tenants/application-stages/update",
    tenants_reorder_application_stages: "/tenants/application-stages/reorder",
    tenants_delete_application_stage: "/tenants/application-stages/delete",

    // Vendor pipeline related APIs:-
    vendor_pipeline_metrics:"/admin/metrics/vendor-pipeline",
    vendor_pipeline_actions:"/admin/metrics/vendor-actions",

    // Saved filter views (user-specific)
    create_saved_views:"/saved-views",
    update_saved_views:"/saved-views",
    delete_saved_views:"/saved-views",
    get_saved_views:"/saved-views",

    // Public job board APIs :-
    get_tenants_logo: "/tenants/get-logo"
  };
};

const envConfig = getEnvConfig();
export default envConfig;